import React from "react";
import Nav from "../Nav"
import Footer from "../Footer";
import CompleteBody from "../CompleteBody";

export default function CompletePage(){
    
    return(
        <div>
            <Nav/>
            <CompleteBody/>
            <Footer/>
        </div>

    );


}